import React from "react";
import { IMenuGroup, IMenuItem } from "../../@types/types";
import { AdditionalLinks } from "./AdditionalLinks";
import GroupItem from "./GroupItem";

interface MenuGroupsProps {
  groups: IMenuGroup[];
  additionalLinks: IMenuItem[];
}

const MenuGroups: React.FC<MenuGroupsProps> = ({ groups, additionalLinks }) => {
  return (
    <div className='menu-groups'>
      {groups.map((group, index) => {
        if (group.isVisible && group?.items?.length) {
          return <GroupItem item={group} key={group.id} index={index} />;
        }
        return null;
      })}
      {additionalLinks.length ? (
        <AdditionalLinks links={additionalLinks} />
      ) : null}
    </div>
  );
};

export default MenuGroups;
